import React from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import config from "./config";

const modules = {
  toolbar: {
    container: [
      [{ header: [1, 2, false] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      ["link", "image", "video"],
      ["code-block", "formula"],
      ["clean"],
      ["emoji"],
    ],
    handlers: {
      image: imageHandler, // Custom image handler
    },
  },
};

const formats = [
  "header",
  "bold",
  "italic",
  "underline",
  "strike",
  "blockquote",
  "list",
  "bullet",
  "indent",
  "link",
  "image",
  "video",
  "code-block",
  "formula",
  "emoji",
];

function imageHandler() {
  const input = document.createElement("input");
  input.setAttribute("type", "file");
  input.setAttribute("accept", "image/*");
  input.click();

  input.onchange = async () => {
    const file = input.files[0];
    const formData = new FormData();
    formData.append("image", file);

    // Send the image to the server
    const response = await fetch(`${config.apiUrl}/upload-image`, {
      method: "POST",
      body: formData,
      credentials: "include",
    });

    if (response.ok) {
      const imageUrl = await response.json();
      const editor = this.quill; // Access the Quill editor instance
      const range = editor.getSelection();
      editor.insertEmbed(range.index, "image", imageUrl.url); // Insert image URL into the editor
    } else {
      console.error("Image upload failed.");
    }
  };
}

export default function TextEditor({ content, setContent }) {
  return (
    <ReactQuill
      value={content}
      onChange={setContent}
      modules={modules}
      formats={formats}
    />
  );
}
